import { useEffect, useState } from 'react';
import { collection, getDocs, query, orderBy } from 'firebase/firestore';
import { db } from '../../firebase';
import AdminSidebar from '../../components/admin/AdminSidebar';
import AdminHeader from '../../components/admin/AdminHeader';
import PropertyTable from '../../components/admin/PropertyTable';
import Spinner from '../../components/Spinner';

export default function AdminProperties() {
  const [properties, setProperties] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('all');

  useEffect(() => {
    fetchProperties();
  }, []);

  async function fetchProperties() {
    try {
      const propertiesRef = collection(db, 'listings');
      const q = query(propertiesRef, orderBy('timestamp', 'desc'));
      const querySnap = await getDocs(q);
      
      const propertiesList = [];
      querySnap.forEach((doc) => {
        propertiesList.push({
          id: doc.id,
          ...doc.data(),
        });
      });
      
      setProperties(propertiesList);
    } catch (error) {
      console.error('Error fetching properties:', error);
    } finally {
      setLoading(false);
    }
  }

  function handleDelete(id) {
    setProperties(properties.filter((property) => property.id !== id));
  }

  const filteredProperties = filter === 'all' 
    ? properties 
    : properties.filter((p) => p.type === filter);

  if (loading) {
    return <Spinner />;
  }

  return (
    <div className="flex">
      <AdminSidebar />
      <div className="flex-1 ml-64">
        <AdminHeader title="Property Management" />
        
        <div className="p-6">
          {/* Filters */}
          <div className="mb-6 flex space-x-4">
            <button
              onClick={() => setFilter('all')}
              className={`px-4 py-2 rounded ${
                filter === 'all'
                  ? 'bg-blue-600 text-white'
                  : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
              }`}
            >
              All ({properties.length})
            </button>
            <button
              onClick={() => setFilter('rent')}
              className={`px-4 py-2 rounded ${
                filter === 'rent'
                  ? 'bg-blue-600 text-white'
                  : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
              }`}
            >
              Rent ({properties.filter((p) => p.type === 'rent').length})
            </button>
            <button
              onClick={() => setFilter('sale')}
              className={`px-4 py-2 rounded ${
                filter === 'sale'
                  ? 'bg-blue-600 text-white'
                  : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
              }`}
            >
              Sale ({properties.filter((p) => p.type === 'sale').length})
            </button>
          </div>

          {/* Properties Table */}
          <PropertyTable 
            properties={filteredProperties} 
            onDelete={handleDelete}
          />
        </div>
      </div>
    </div>
  );
}
